import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';

import { PhxListModule } from '../list/list.module';

import { PhxMenuComponent } from './phx-menu/phx-menu.component';
import { PhxMenuItemComponent, PhxMenuItemLinkComponent } from './phx-menu-item/phx-menu-item.component';
import { PhxCheckboxModule } from '../checkbox/checkbox.module';
import { PhxIconModule } from '../icon/icon.module';
import { PhxIconButtonModule } from '../icon-button/phx-icon-button.module';

@NgModule({
  declarations: [
    PhxMenuComponent,
    PhxMenuItemComponent,
    PhxMenuItemLinkComponent
  ],
  exports: [
    PhxMenuComponent,
    PhxMenuItemComponent,
    PhxMenuItemLinkComponent
  ],
  imports: [
    CommonModule,
    A11yModule,
    PhxListModule,
    PhxCheckboxModule,
    PhxIconModule,
    PhxIconButtonModule
  ],
  providers: [],
})
export class PhxMenuModule { }
